module.exports = __webpack_public_path__ + "img/rocking-chairs-01.8711b0ce.jpeg";